module.exports = __webpack_public_path__ + "static/media/topgoalscorer.c8ff0690.jpg";